import { getFooterLegalLinks } from "utilities/getFooterLegalLinks";

export function getPrivacyAndTermsOfUseConsent(preferredLanguage?: string | null) {
  const { privacyPolicy, termsOfUse } = getFooterLegalLinks(preferredLanguage);

  return (
    <>
      By clicking “Continue”, I acknowledge that I have reviewed the{" "}
      <a href={privacyPolicy} target="_blank" rel="noreferrer">
        Privacy Policy
      </a>{" "}
      and agree to the{" "}
      <a href={termsOfUse} target="_blank" rel="noreferrer">
        Terms of Use
      </a>.
    </>
  );
}

export function getWelcomePageConsent(preferredLanguage?: string | null) {
  const { electronicConsent, partners } = getFooterLegalLinks(preferredLanguage);

  return (
    <>
      By clicking “Continue”, I agree by ESIGN signature 1) to receive disclosures and communications about my loan inquiry and any loan that I obtain
      from New American Funding (NAF) in electronic form (I confirm I have access to a working computer and/or digital device where I can view and
      manage my information); and 2) to the{" "}
      <a href={electronicConsent} target="_blank" rel="noreferrer">
        Electronic Consent Agreement
      </a>
      ; and 3) I consent to NAF, its{" "}
      <a href={partners} target="_blank" rel="noreferrer">
        partners
      </a>, and parties calling on their behalf to contact me at the number that I provided on the previous screen for marketing purposes, including through
      the use of email, automated technology, artificial or prerecorded voice, AI generative voice, and SMS/MMS messages. I acknowledge my consent is
      not required to obtain any good or service, and that I can be connected with NAF without providing consent by calling (800) 890-1057. I consent to
      be contacted even if my phone number or email address appears on a NAF Do Not Contact/Do Not Email list, a State or National Do Not Call Registry
      or any other Do Not Contact/Do Not Email list.
    </>
  );
}
